import ApiService from "@/core/services/ApiService";

class InstitutionService {

    //lista de instituciones
    public static getData(params) {
        ApiService.setHeader()
        return ApiService.post('api/institution',params)
    }

    public static save(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/institution/save', data)
    }

    public static edit(id: string) {
        ApiService.setHeader()
        return ApiService.get(`api/institution/${id}`, 'edit')
    }

    public static update (id, data) {
        ApiService.setHeader()
        return ApiService.put(`api/institution/${id}/update`,data)
    }

    public static delete(id: string) {
        ApiService.setHeader()
        return ApiService.delete(`api/institution/${id}`, 'delete')
    }

    //eventos asignados
    public static getEvents(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/institution/events', data)
    }

    /*
    public static mela(id: any, slug: string){
        ApiService.setHeader()
        return ApiService.get(`api/institution/${id}`, slug)
    }
    */

    //configuracion
    public static getSetting(){
        ApiService.setHeader()
        return ApiService.get('api/institution', 'setting')
    }

}

export default InstitutionService;